var flkty5 = new Flickity(".featured-carousel-drawer", {
  selectedAttraction: 0.12,
  friction: 0.9,
  groupCells: "100%",
  cellAlign: "left",
  imagesLoaded: true,
  prevNextButtons: true,
  wrapAround: false,
  pageDots: false,
  draggable: true,
});
flkty5.resize();

const sliderCards = document.querySelectorAll(
  ".featured-carousel-drawer .carousel-cell"
);

const sliderCardsWrappers = document.querySelectorAll(
  ".featured-carousel-drawer .carousel-cell .card-wrapper"
);

window.addEventListener("resize", (event) => {
  sliderCards.forEach((card) => {
    card.style.height = "fit-content";
  });
  sliderCardsWrappers.forEach((card) => {
    card.style.height = "fit-content";
  });
  flkty5.resize();
  sliderCards.forEach((card) => {
    card.style.height = "100%";
  });
  sliderCardsWrappers.forEach((card) => {
    card.style.height = "100%";
  });
});

var drawer = function () {
  /**
   * Element.closest() polyfill
   * https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
   */
  if (!Element.prototype.closest) {
    if (!Element.prototype.matches) {
      Element.prototype.matches =
        Element.prototype.msMatchesSelector ||
        Element.prototype.webkitMatchesSelector;
    }
    Element.prototype.closest = function (s) {
      var el = this;
      var ancestor = this;
      if (!document.documentElement.contains(el)) return null;
      do {
        if (ancestor.matches(s)) return ancestor;
        ancestor = ancestor.parentElement;
      } while (ancestor !== null);
      return null;
    };
  }

  //
  // Settings
  //
  var settings = {
    speedOpen: 50,
    speedClose: 350,
    activeClass: "is-active",
    visibleClass: "is-visible",
    selectorTarget: "[data-drawer-target]",
    selectorTrigger: "[data-drawer-trigger]",
    selectorClose: "[data-drawer-close]",
  };

  //
  // Methods
  //
  // Toggle accessibility
  var toggleccessibility = function (event) {
    if (event.getAttribute("aria-expanded") === "true") {
      event.setAttribute("aria-expanded", false);
    } else {
      event.setAttribute("aria-expanded", true);
    }
  };
  // Open Drawer
  var openDrawer = function (trigger) {
    // Find target
    var target = document.getElementById(
      typeof trigger === "string"
        ? trigger
        : trigger.getAttribute("aria-controls")
    );
    // Make it active
    target.classList.add(settings.activeClass);
    // Make body overflow hidden so it's not scrollable
    document.documentElement.style.overflow = "hidden";
    // Toggle accessibility
    if (typeof trigger !== "string") {
      toggleccessibility(trigger);
    }
    // Make it visible
    setTimeout(function () {
      target.classList.add(settings.visibleClass);
    }, settings.speedOpen);

    sliderCards.forEach((card) => {
      card.style.height = "fit-content";
    });
    sliderCardsWrappers.forEach((card) => {
      card.style.height = "fit-content";
    });
    flkty5.resize();
    // resizing for full width cards
    sliderCards.forEach((card) => {
      card.style.height = "100%";
    });
    sliderCardsWrappers.forEach((card) => {
      card.style.height = "100%";
    });
  };
  // Close Drawer
  var closeDrawer = function (event) {
    // Find target
    var closestParent = event.closest(settings.selectorTarget),
      childrenTrigger = document.querySelector(
        '[aria-controls="' + closestParent.id + '"'
      );
    // Make it not visible
    closestParent.classList.remove(settings.visibleClass);
    // Remove body overflow hidden
    document.documentElement.style.overflow = "";
    // Toggle accessibility
    toggleccessibility(childrenTrigger);
    // Make it not active
    setTimeout(function () {
      closestParent.classList.remove(settings.activeClass);
    }, settings.speedClose);
  };
  // Click Handler
  var clickHandler = function (event) {
    // Find elements
    var toggle = event.target,
      open = toggle.closest(settings.selectorTrigger),
      close = toggle.closest(settings.selectorClose);
    // Open drawer when the open button is clicked
    if (open) {
      openDrawer(open);
    }
    // Close drawer when the close button (or overlay area) is clicked
    if (close) {
      closeDrawer(close);
    }
    // Prevent default link behavior
    if (open || close) {
      // event.preventDefault();
    }
  };
  // Keydown Handler, handle Escape button
  var keydownHandler = function (event) {
    if (event.key === "Escape" || event.keyCode === 27) {
      // Find all possible drawers
      var drawers = document.querySelectorAll(settings.selectorTarget),
        i;
      // Find active drawers and close them when escape is clicked
      for (i = 0; i < drawers.length; ++i) {
        if (drawers[i].classList.contains(settings.activeClass)) {
          closeDrawer(drawers[i]);
        }
      }
    }
  };

  //
  // Inits & Event Listeners
  //
  document.addEventListener("click", clickHandler, false);
  document.addEventListener("keydown", keydownHandler, false);
  window.addEventListener("custom:open-cart-drawer", () =>
    openDrawer("drawer-name")
  );
};
drawer();
